import { fetchApi } from '../api';
import { MomentApplication } from './moments.types';
import sortBy from 'lodash/sortBy';

export const fetchMoments = async (
  subscriptionId: string,
  authToken: string,
): Promise<MomentApplication[] | undefined> => {
  try {
    const res = await fetchApi({
      url: `/subscriptions/${subscriptionId}/moment-applications`,
      authToken,
    });

    if (!res.ok) {
      throw new Error('Network response was not ok');
    }

    const { momentApplications = [] } = await res.json();

    return sortBy(momentApplications, (ma) => ma.moment.position);
  } catch (error) {
    console.error(error);
  }
};

export const claimRewardFetch = async ({
  momentId,
  subscriptionId,
  authToken,
  productVariantGId,
}: {
  momentId: string;
  subscriptionId: string;
  authToken: string;
  productVariantGId?: string;
}): Promise<MomentApplication['id']> => {
  const response = await fetchApi({
    url: `/subscriptions/${subscriptionId}/moment-applications/${momentId}/claim`,
    method: 'POST',
    authToken,
    body: {
      productVariantGId,
    },
  });

  if (!response.ok) {
    throw new Error('Network response was not ok');
  }

  return momentId;
};
